// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__2WBTT","ModalOpen":"Modal_ModalOpen__1f3ef","ModalBody":"Modal_ModalBody__sPUya","ModalBodyOpen":"Modal_ModalBodyOpen__8K1KL"};